import * as React from "react";
import {
  Dropdown as UIDropdown,
  DropdownProps as UIDropdownProps,
} from "@stemscopes/ui";
import classNames from "classnames";
import styles from "./Dropdown.module.css";

interface DropdownProps extends UIDropdownProps {
  iconAuto?: boolean;
  iconClassName?: string;
  contentContainerClassName?: string;
  wheelPropagation?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  iconAuto,
  iconClassName,
  buttonClassName,
  contentContainerClassName,
  size = "medium",
  ...rest
}) => (
  <UIDropdown
    {...rest}
    size={size}
    buttonClassName={
      typeof buttonClassName === "function"
        ? (opened) =>
            classNames(styles.opener, buttonClassName(opened), {
              [styles.small]: size === "small",
              [styles.medium]: size === "medium",
              [styles.large]: size === "large",
              [styles.clear]: rest.variant === "clear",
              [styles.secondary]: rest.variant === "secondary",
            })
        : classNames(styles.opener, buttonClassName, {
            [styles.small]: size === "small",
            [styles.medium]: size === "medium",
            [styles.large]: size === "large",
            [styles.clear]: rest.variant === "clear",
            [styles.secondary]: rest.variant === "secondary",
          })
    }
    prefixClassName={classNames(iconClassName, styles.icon, {
      [styles.iconAuto]: iconAuto,
    })}
    suffixClassName={classNames(iconClassName, styles.icon, {
      [styles.iconAuto]: iconAuto,
    })}
    contentContainerClassName={classNames(
      contentContainerClassName,
      styles.contentContainer,
    )}
  />
);

export default Dropdown;
